import { filters, guestFilters } from "api/filters";
import { useUserContext } from "context/userContext";
import React, { useEffect, useMemo, useState } from "react";
import { useCart } from "../../context/CartContext";
import PaginationControl from "../PaginationControl";
import FiltersList from "./FiltersList";

const FiltersDataCards = ({ filterSearch, isLoading, setIsLoading }) => {
  const [quantity, setQuantity] = useState({});
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const { addToCart, addToRequestForm } = useCart();
  const [dataList, setDataList] = useState(null);
  const { isAuth } = useUserContext();

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = isAuth
          ? await filters(filterSearch, controller.signal)
          : await guestFilters(filterSearch, controller.signal);

        if (response && response.data) {
          const products = response.data?.products ?? response.data ?? [];
          setDataList(products.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataList([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [filterSearch, isAuth, filters]);

  const filteredData = useMemo(() => {
    if (!dataList) return [];
    return dataList;
  }, [dataList, filterSearch]);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleQuantityChange = (id, value) => {
    setQuantity((prev) => ({
      ...prev,
      [id]: Math.max(1, Math.min(100, parseInt(value) || 0)),
    }));
  };

  const handleAddToCart = (filter) => {
    const numberOfItems = quantity[filter.id] || 1;

    if (isAuth) {
      addToCart(filter, numberOfItems);
    } else {
      addToRequestForm(filter, numberOfItems);
    }
  };

  return (
    !isLoading &&
    dataList && (
      <>
        <FiltersList
          paginatedData={paginatedData}
          quantity={quantity}
          handleQuantityChange={handleQuantityChange}
          handleAddToCart={handleAddToCart}
        />
        {filteredData.length > itemsPerPage && (
          <PaginationControl
            pageCount={pageCount}
            page={page}
            handlePageChange={handlePageChange}
          />
        )}
      </>
    )
  );
};

export default FiltersDataCards;
